import type { HTMLAttributes } from 'react';
import React from 'react';
import classNames from 'classnames';
import { Img } from '@/components/atoms/Img';

import styles from './index.module.scss';

export interface LogoPictureProps extends Omit<HTMLAttributes<HTMLAnchorElement>, 'href'> {
  readonly url: string;
  readonly lightLogoSrc?: string;
  readonly darkLogoSrc?: string;
}

export function LogoPicture({
  url,
  darkLogoSrc = '/logo/logo-light-text-dark-horizontal_buctbs.svg',
  lightLogoSrc = '/logo/logo-dark-text-light-horizontal_mucglg.svg',
  className,
  ...props
}: LogoPictureProps): JSX.Element {
  return (
    <a href={url} className={classNames(LogoPicture.displayName, styles.component)} {...props}>
      <Img
        src={lightLogoSrc}
        alt="fixter logo"
        className={styles.desktop}
        width={113}
        height={32}
        quality={75}
        provider="cloudinary"
      />

      <Img
        src={darkLogoSrc}
        alt="fixter logo"
        className={styles.mobile}
        width={113}
        height={32}
        quality={75}
        provider="cloudinary"
      />
    </a>
  );
}
LogoPicture.displayName = 'LogoPicture';
